import { customTextBlock, heading, paragraph } from "../../../text/nodes"
import { ArticleListItem as ArticleListItemEditor } from "./article-list-item"
import { ArticleListItemSettings } from "./article-list-item-settings"
import ArticleListItemPreview from "./article-list-item-preview.png"
import { getFont } from "app/regions/blocks/shared/fonts"

export const ArticleListItem = {
  name: "ArticleListItem",
  label: "article list item",
  EditorComponent: ArticleListItemEditor,
  SettingsComponent: ArticleListItemSettings,
  image: ArticleListItemPreview,
  defaultProperties: {
    backgroundColor: "#ffffff",
    headingColor: "#000000",
    textColor: "#4d4d4d",
    image: "",
    imageUrl: "",
    alt: "",
    horizontalPadding: 0,
    verticalPadding: 0,
    marginTop: 24,
    marginBottom: 24,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    columnRatio: 25,
    borderColor: "#000000",
    borderTopWidth: 0,
    borderRightWidth: 0,
    borderLeftWidth: 0,
    borderBottomWidth: 0,
    imageBorderRadius: 0,
    headingFontFamily: getFont("Charter"),
    headingFontWeight: 500,
    textFontFamily: getFont("Verdana"),
    textFontWeight: 400,
    gap: 30
  },
  defaultChildren: [
    customTextBlock([
      heading("two", "Title"),
      paragraph("Lorem ipsum dolor sit...")
    ])
  ]
}
